import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import type { CalendarEventDetail } from "./types";

/** Detail panel data for a single event. `null` eventId disables the query. */
export function useEventDetail(eventId: string | null) {
  return useQuery<CalendarEventDetail>({
    queryKey: ["calendar-event", eventId],
    queryFn: () => api.getCalendarEvent(eventId!),
    enabled: Boolean(eventId),
    staleTime: 60_000,
  });
}
